"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const messages_1 = __importDefault(require("../common/util/constants/messages"));
const MiniProviderPageList_1 = __importDefault(require("./MiniProviderPageList"));
const MiniProviderCardPageList_styles_1 = require("./MiniProviderCardPageList.styles");
const useProviderCardUtilities_1 = require("../MiniProviderCardList/useProviderCardUtilities");
const MiniProviderCardPageList = ({ createAvailabilityUrl, createProviderUrl, providers, track, viewAvailabilityLinkTarget = '_blank', viewProviderLinkTarget = '_blank', intl }) => {
    const { viewAvailabilityCallback, viewProviderCallback } = (0, useProviderCardUtilities_1.useProviderCardUtilities)({
        track,
        viewAvailabilityLinkTarget,
        viewProviderLinkTarget,
        createAvailabilityUrl,
        createProviderUrl
    });
    return (react_1.default.createElement(MiniProviderPageList_1.default, { headerMessage: messages_1.default.miniProviderPageListHeader }, providers.map((_a) => {
        var { location } = _a, detailedProvider = __rest(_a, ["location"]);
        const key = `${detailedProvider.provider.id}-${location === null || location === void 0 ? void 0 : location.id}`;
        return (react_1.default.createElement(MiniProviderCardPageList_styles_1.PageListCard, Object.assign({ key: key }, detailedProvider, { onViewAvailability: viewAvailabilityCallback(detailedProvider), onViewProvider: viewProviderCallback(detailedProvider), viewAvailabilityUrl: createAvailabilityUrl(detailedProvider.provider), viewProviderUrl: createProviderUrl(detailedProvider.provider), compactProviderSpecialties: true, "aria-live": "polite", "aria-atomic": true, "aria-label": intl.formatMessage(messages_1.default.ariaMiniProviderCardPageListLabel), "data-testid": `MiniProviderCard-${key}`, viewAvailabilityLinkTarget: viewAvailabilityLinkTarget, viewProviderLinkTarget: viewProviderLinkTarget })));
    })));
};
exports.default = (0, intl_1.injectIntl)(MiniProviderCardPageList);
//# sourceMappingURL=MiniProviderCardPageList.js.map